import { render, staticRenderFns } from "./Footer3.vue?vue&type=template&id=7ae5dfbc&scoped=true"
import script from "./Footer3.vue?vue&type=script&lang=js"
export * from "./Footer3.vue?vue&type=script&lang=js"
import style0 from "./Footer3.vue?vue&type=style&index=0&id=7ae5dfbc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ae5dfbc",
  null
  
)

export default component.exports